// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProgressBar_progressBarComponent_2fK-L{position:relative;margin:0 auto;display:flex;padding-top:41px}.ProgressBar_bar_eDj-x{position:absolute;top:41px;height:2px;background-color:#ccc;width:100%}.ProgressBar_barNewDesign_3MVG0{background-color:#ece8e5}.ProgressBar_progress_tvQ6b{top:39px;position:absolute;z-index:10;height:6px;background-color:#9cbc76;border-radius:4px}.ProgressBar_progressNewDesign_Xg56_{background-color:#cc6b4a}", ""]);
// Exports
exports.locals = {
	"progressBarComponent": "ProgressBar_progressBarComponent_2fK-L",
	"bar": "ProgressBar_bar_eDj-x",
	"barNewDesign": "ProgressBar_barNewDesign_3MVG0",
	"progress": "ProgressBar_progress_tvQ6b",
	"progressNewDesign": "ProgressBar_progressNewDesign_Xg56_"
};
module.exports = exports;
